function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { cloneDeep, debounce, find } from 'lodash';
import { Icon, Breadcrumb, Spin, Input, Button } from 'mkui-fd';
import { buildSelectedData, buildBreadcrumbData, buildSelectedCodes, getSearchResult } from './util';
import noop from '../_util/noop';
var Search = Input.Search;

var Panel = /*#__PURE__*/function (_React$Component) {
  _inherits(Panel, _React$Component);

  _createClass(Panel, null, [{
    key: "getDerivedStateFromProps",

    /** *******************static************************** */
    value: function getDerivedStateFromProps(props, state) {
      if (Array.isArray(props.data) && props.data.length && !state.data.length) {
        return {
          data: props.data,
          selectedMultiple: props.value || []
        };
      }

      return null;
    }
    /** *******************life cycle************************** */

  }]);

  function Panel(props) {
    var _this;

    _classCallCheck(this, Panel);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Panel).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "selectCategoryHandle", function (category, event) {
      var _this$props = _this.props,
          api = _this$props.api,
          keyMap = _this$props.keyMap;
      var _this$state = _this.state,
          data = _this$state.data,
          selectedCodes = _this$state.selectedCodes;
      event && event.stopPropagation();

      if (!event && category[keyMap.selectable] === false) {
        return;
      }

      if (!category.inited) {
        _this.setState({
          spinning: true
        });

        api(category).then(function () {
          var response = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

          if (Array.isArray(category.children)) {
            category.children = category.children.concat(response);
          } else {
            category.children = response;
          }

          category.inited = true;

          _this.setState({
            selectedCodes: [].concat(_toConsumableArray(selectedCodes), [category.code]),
            data: cloneDeep(data),
            spinning: false
          });
        });
      } else {
        _this.setState({
          selectedCodes: [].concat(_toConsumableArray(selectedCodes), [category.code]),
          data: cloneDeep(data)
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "selectOptionHandle", function (option) {
      var _this$props2 = _this.props,
          onSelect = _this$props2.onSelect,
          multiple = _this$props2.multiple,
          keyMap = _this$props2.keyMap;
      var selectedMultiple = _this.state.selectedMultiple;

      if (option[keyMap.selectable] === false) {
        return;
      }

      if (multiple) {
        if (!find(selectedMultiple, {
          code: option.code
        })) {
          _this.setState({
            selectedMultiple: [].concat(_toConsumableArray(selectedMultiple), [option])
          });
        }

        return;
      }

      if (onSelect) {
        onSelect([option]);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "clickBreadcrumbHandle", function (item) {
      var selectedCodes = _this.state.selectedCodes;
      var codes = buildSelectedCodes(selectedCodes, item.code);

      _this.setState({
        selectedCodes: codes
      });
    });

    _defineProperty(_assertThisInitialized(_this), "searchHandle", function (e) {
      var keywords = e.target.value.trim();

      if (keywords) {
        _this.search(keywords);
      } else {
        _this.setState({
          searchResult: null
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "removeMultipleHandle", function (code) {
      var selectedMultiple = _this.state.selectedMultiple;

      _this.setState({
        selectedMultiple: selectedMultiple.filter(function (item) {
          return item.code !== code;
        })
      });
    });

    _defineProperty(_assertThisInitialized(_this), "confirmMultipleHandle", function () {
      var onSelect = _this.props.onSelect;
      var selectedMultiple = _this.state.selectedMultiple;

      if (onSelect) {
        onSelect(_toConsumableArray(selectedMultiple));
      }
    });

    _this.state = {
      data: [],
      // 所有的树数据
      selectedCodes: [],
      // 记录选中的目录，可以生成面包屑
      spinning: false,
      selectedMultiple: [] // 记录多选选中结果

    };
    _this.search = debounce(_this.search, 500);
    return _this;
  }
  /** *******************handle************************** */


  _createClass(Panel, [{
    key: "search",

    /** *******************inner method************************** */
    value: function search(keywords) {
      var _this2 = this;

      var api = this.props.api;
      this.setState({
        spinning: true
      });
      api({
        keywords: keywords
      }).then(function (response) {
        var result = getSearchResult(response);

        _this2.setState({
          searchResult: result,
          spinning: false
        });
      });
    }
    /** *******************render************************** */

  }, {
    key: "renderSearchResult",
    value: function renderSearchResult() {
      var _this3 = this;

      var _this$props3 = this.props,
          prefixCls = _this$props3.prefixCls,
          searchResultRender = _this$props3.searchResultRender;
      var searchResult = this.state.searchResult;
      return searchResult && searchResult.length > 0 ? React.createElement("ul", {
        className: "".concat(prefixCls, "-search-result")
      }, searchResult.map(function (item) {
        return React.createElement("li", {
          key: item.code,
          onClick: function onClick() {
            _this3.selectOptionHandle(item);
          }
        }, searchResultRender(item));
      })) : React.createElement("div", {
        className: "".concat(prefixCls, "-search-empty")
      }, "\u672A\u641C\u7D22\u5230\u76F8\u5173\u8BB0\u5F55\u3002");
    }
  }, {
    key: "renderContent",
    value: function renderContent() {
      var _this4 = this;

      var _this$props4 = this.props,
          prefixCls = _this$props4.prefixCls,
          showBreadcrumb = _this$props4.showBreadcrumb,
          keyMap = _this$props4.keyMap;
      var _this$state2 = this.state,
          data = _this$state2.data,
          selectedCodes = _this$state2.selectedCodes;
      var selectedData = buildSelectedData(data, selectedCodes);
      var isEmpty = !selectedData.length;
      return React.createElement(Fragment, null, showBreadcrumb && this.renderBreadcrumb(), React.createElement("div", {
        className: "".concat(prefixCls, "-list")
      }, isEmpty ? React.createElement("div", {
        className: "".concat(prefixCls, "-list-empty")
      }, "\u65E0\u9009\u9879\u5185\u5BB9") : React.createElement("ul", null, selectedData.map(function (item) {
        return item.leaf ? React.createElement("li", {
          key: item.code,
          className: item[keyMap.selectable] === false ? 'not-selectable' : '',
          onClick: function onClick() {
            _this4.selectOptionHandle(item);
          }
        }, React.createElement("span", null, React.createElement(Icon, {
          className: "".concat(prefixCls, "-list-icon"),
          type: "file"
        }), item.name)) : React.createElement("li", {
          key: item.code,
          className: item[keyMap.selectable] === false ? 'not-selectable' : '',
          onClick: function onClick() {
            item[keyMap.selectable] === true ? _this4.selectOptionHandle(item) : _this4.selectCategoryHandle(item);
          }
        }, React.createElement("span", null, React.createElement(Icon, {
          className: "".concat(prefixCls, "-list-icon"),
          type: "folder",
          theme: "filled"
        }), item.name), React.createElement(Icon, {
          className: "".concat(prefixCls, "-arrow-icon"),
          type: "right",
          onClick: function onClick(event) {
            _this4.selectCategoryHandle(item, event);
          }
        }));
      }))));
    }
  }, {
    key: "renderSearch",
    value: function renderSearch() {
      var _this$props5 = this.props,
          prefixCls = _this$props5.prefixCls,
          searchPlaceholder = _this$props5.searchPlaceholder;
      return React.createElement("div", {
        className: "".concat(prefixCls, "-search")
      }, React.createElement(Search, {
        className: "".concat(prefixCls, "-search-input"),
        placeholder: searchPlaceholder,
        onChange: this.searchHandle
      }));
    }
  }, {
    key: "renderMultiple",
    value: function renderMultiple() {
      var _this5 = this;

      var prefixCls = this.props.prefixCls;
      var selectedMultiple = this.state.selectedMultiple;
      return selectedMultiple && selectedMultiple.length > 0 ? React.createElement("div", {
        className: "".concat(prefixCls, "-selected")
      }, React.createElement("div", {
        className: "".concat(prefixCls, "-selected-list")
      }, selectedMultiple.map(function (item) {
        return React.createElement("span", {
          key: item.code
        }, item.name, React.createElement(Icon, {
          onClick: function onClick() {
            return _this5.removeMultipleHandle(item.code);
          },
          type: "close",
          className: "".concat(prefixCls, "-selected-remove")
        }));
      })), React.createElement(Button, {
        type: "primary",
        size: "small",
        onClick: this.confirmMultipleHandle
      }, "\u786E\u5B9A")) : null;
    } // renderFrequent() {
    //   const { prefixCls } = this.props;
    //   return (
    //     <div className={`${prefixCls}-frequent`}>
    //       <div className={`${prefixCls}-frequent-title`}>最近选择</div>
    //       <ul>
    //         <li>云报销</li>
    //         <li>云报销</li>
    //         <li>云报销</li>
    //       </ul>
    //     </div>
    //   );
    // }

  }, {
    key: "renderBreadcrumb",
    value: function renderBreadcrumb() {
      var _this6 = this;

      var _this$props6 = this.props,
          prefixCls = _this$props6.prefixCls,
          rootName = _this$props6.rootName;
      var _this$state3 = this.state,
          data = _this$state3.data,
          selectedCodes = _this$state3.selectedCodes;
      var breadcrumbData = buildBreadcrumbData(data, selectedCodes, rootName);
      return breadcrumbData ? React.createElement("div", {
        className: "".concat(prefixCls, "-breadcrumbs")
      }, React.createElement(Breadcrumb, null, breadcrumbData.map(function (item, index, arr) {
        return index === arr.length - 1 ? React.createElement(Breadcrumb.Item, {
          key: item.code
        }, item.name) : React.createElement(Breadcrumb.Item, {
          key: item.code
        }, React.createElement("a", {
          onClick: function onClick() {
            return _this6.clickBreadcrumbHandle(item);
          }
        }, item.name));
      }))) : null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props7 = this.props,
          prefixCls = _this$props7.prefixCls,
          showSearch = _this$props7.showSearch,
          multiple = _this$props7.multiple;
      var _this$state4 = this.state,
          searchResult = _this$state4.searchResult,
          spinning = _this$state4.spinning;
      return React.createElement("div", {
        className: classNames("".concat(prefixCls))
      }, showSearch && this.renderSearch(), multiple && this.renderMultiple(), React.createElement(Spin, {
        spinning: spinning
      }, showSearch && searchResult ? this.renderSearchResult() : this.renderContent()));
    }
  }]);

  return Panel;
}(React.Component);

_defineProperty(Panel, "propTypes", {
  prefixCls: PropTypes.string,
  api: PropTypes.func,
  onSelect: PropTypes.func,
  showSearch: PropTypes.bool,
  searchPlaceholder: PropTypes.string,
  showBreadcrumb: PropTypes.bool,
  rootName: PropTypes.string,
  multiple: PropTypes.bool,
  searchResultRender: PropTypes.func
});

_defineProperty(Panel, "defaultProps", {
  prefixCls: 'mkui-enhanced-tree-select-panel',
  api: noop,
  onSelect: noop,
  showSearch: false,
  searchPlaceholder: '输入名称搜索',
  showBreadcrumb: true,
  rootName: '全部',
  multiple: false,
  searchResultRender: function searchResultRender(item) {
    return item.name;
  },
  // 为了方便做数据映射，加了keyMap属性，因为接口定义的字段名和组件定义的字段名经常不一致
  keyMap: {
    selectable: 'selectable'
  }
});

export default Panel;
//# sourceMappingURL=Panel.js.map
